<template>
  <div class="box">
    <div class="top">
      <div class="left">
        <img src="@/assets/img/tlogo.png" alt="" />
      </div>
      <div class="right">
        <div v-for="(item, index) in tlist" :key="item" class="e" :class="{ pbox: res == index }">
          <img src="@/assets/img/logo.png" alt="" v-if="res == index" />
          {{ item }}
        </div>
      </div>
    </div>

    <div class="foot">
      公益为先，免费前沿治疗 <br />
      让爱洒满二三线！
    </div>
    <div class="footer">
      冀ICP备2024071986号
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue'
const tlist = ref(['首页', '关于', '新闻', '加入', '联系'])

const res = ref(0)
</script>

<style scoped lang="less">
* {
  box-sizing: border-box;
}
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  position: absolute;
  bottom: 10px;
  width: 100%;
}
.box {
  width: 100%;
  height: 100vh;
  background-image: url(@/assets/img/banner.png);
  background-size: 100%;
  overflow: hidden;
  position: relative;
}
.foot {
  position: absolute;
  background: #41c48a;
  width: 760px;
  height: 200px;
  background: #41c48a99;
  bottom: 140px;
  left: 140px;
  display: flex;
  justify-content: center;
  align-items: center;

  font-family: SourceHanSansSC-Heavy;
  font-weight: 900;
  font-size: 48px;
  color: #ffffff;
  text-shadow: 0 0 10px #00000061;
}
.top {
  display: flex;
}
.left {
  margin-right: 200px;
  img {
    width: 300px;
  }
}
.e {
  font-family: SourceHanSansSC-Medium;
  font-weight: 500;
  font-size: 18px;
  margin-right: 100px;
  cursor: pointer;
  color: #00000099;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    height: 18px;
    margin-right: 10px;
  }
}
.right {
  display: flex;
}
.pbox {
  font-family: SourceHanSansSC-Medium;
  font-weight: 500;
  font-size: 18px;
  color: #000000;
}
</style>
